"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Suffix = exports.Prefix = exports.InputPrefixSuffixWrapper = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tokens = require("../../../tokens");
var _constants = require("./constants");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const StyledInputPrefixSuffixWrapper = _styledComponents.default.div.withConfig({
  displayName: "StyledInputPrefixSuffixWrapper",
  componentId: "sc-cxosra-0"
})(["margin:12px 0 0;position:relative;", " input{max-width:100%;margin:0;}&:focus-within input{box-shadow:0 0 0 ", " ", ";}"], _ref => {
  let {
    $width
  } = _ref;
  return $width && `max-width: ${$width};`;
}, _tokens.INTERACTIVE.OUTLINE_WEIGHT, _tokens.COLOR.STATE.ACTIVE);
const InputPrefixSuffixWrapper = _ref2 => {
  let {
    width,
    children
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(StyledInputPrefixSuffixWrapper, {
    $width: width
  }, children);
};
exports.InputPrefixSuffixWrapper = InputPrefixSuffixWrapper;
const StyledPrefixSuffix = _styledComponents.default.span.withConfig({
  displayName: "StyledPrefixSuffix",
  componentId: "sc-cxosra-1"
})(["position:absolute;pointer-events:none;width:100%;box-sizing:border-box;padding:", "px;color:", ";", " ", ""], _constants.INPUT_PADDING + 2, _tokens.COLOR.GREY.DARK, _ref3 => {
  let {
    $suffix
  } = _ref3;
  return $suffix && `
    text-align: right;
  `;
}, _ref4 => {
  let {
    $width,
    $suffix
  } = _ref4;
  return $width && `
    ~ input,
    ~ textarea {
      padding-${$suffix ? 'right' : 'left'}: ${_constants.INPUT_PADDING + $width + parseInt(_tokens.GTR.XS)}px;
    }
  `;
});
const PrefixSuffix = _ref5 => {
  let {
    children,
    suffix
  } = _ref5;
  const ref = (0, _react.useRef)(null);
  const [width, setWidth] = (0, _react.useState)(16);
  (0, _react.useEffect)(() => {
    if (ref.current) {
      setWidth(ref.current.offsetWidth);
    }
  }, [children]);
  return /*#__PURE__*/_react.default.createElement(StyledPrefixSuffix, {
    $width: width,
    $suffix: !!suffix,
    "aria-hidden": true
  }, /*#__PURE__*/_react.default.createElement("span", {
    ref: ref
  }, children));
};
const Prefix = props => /*#__PURE__*/_react.default.createElement(PrefixSuffix, props);
exports.Prefix = Prefix;
const Suffix = props => /*#__PURE__*/_react.default.createElement(PrefixSuffix, _extends({
  suffix: true
}, props));
exports.Suffix = Suffix;